<template>
    <div>
        <CDropdown color="primary" :toggler-text="$t('actions')" class="m-2">
            <CDropdownItem tag="div" @click="logIn">
                {{ $t("Login") }}
            </CDropdownItem>
            <CDropdownItem tag="div" @click="refreshAccess">
                {{ $t("Refresh access") }}
            </CDropdownItem>
        </CDropdown>
    </div>
</template>

<script>
/**Components */
import CustomTable from "~/components/CustomTable";

/** Mixins */
import baseMixin from "~/mixins/base.js";

/** Others */
import {
    cilSave,
    cilArrowThickFromRight,
    cilSettings,
    cilPencil,
    cilTrash,
    cilPlus,
} from "@coreui/icons";
import {
    ZOHO_REFRESH_ACCESS_TOKEN_ACTION_ID,
    ZOHO_GENERATE_ACCESS_TOKEN_ACTION_ID,
} from "~/pages/app/Services/Triggers/Config/Types";

export default {
    name: "ZohoActionsManager",
    mixins: [baseMixin],
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilSettings,
        cilPencil,
        cilTrash,
        cilPlus,
    },
    consts: {
        ZOHO_REFRESH_ACCESS_TOKEN_ACTION_ID,
        ZOHO_GENERATE_ACCESS_TOKEN_ACTION_ID,
    },
    components: {
        CustomTable,
    },
    data() {
        return {
            modals: {},
            modelFields: [],
        };
    },
    props: {
        integration: {
            required: true,
        },
    },
    watch: {},
    methods: {
        async refreshAccess() {
            this.updatePageLoading(true);
            try {
                const response = await this.fetcher({
                    url: `/connector.api/integrations/${this.integration.uuid}/actions/${this.$options.consts.ZOHO_REFRESH_ACCESS_TOKEN_ACTION_ID}/execute`,
                });

                await this.fetcher({
                    url: "/connector.api/integrations/:uuid",
                    params: {
                        uuid: this.integration.uuid,
                    },
                    method: "PATCH",
                    data: {
                        temporary_credentials: response.pluginActionResponse,
                    },
                });
                this.showMessageSuccess();
            } catch (error) {
                console.log("Herreee");
                this.showMessageError();
            } finally {
                this.updatePageLoading(false);
            }
        },
        async logIn() {
            this.updatePageLoading(true);
            try {
                const response = await this.fetcher({
                    url: `/connector.api/integrations/${this.integration.uuid}/actions/${this.$options.consts.ZOHO_GENERATE_ACCESS_TOKEN_ACTION_ID}/execute`,
                });

                await this.fetcher({
                    url: "/connector.api/integrations/:uuid",
                    params: {
                        uuid: this.integration.uuid,
                    },
                    method: "PATCH",
                    data: {
                        temporary_credentials: response.pluginActionResponse,
                    },
                });
                this.showMessageSuccess();
            } catch (error) {
                this.showMessageError(error);
            } finally {
                this.updatePageLoading(false);
            }
        },
    },
    mounted() {},
};
</script>

<style></style>
